module.exports = __webpack_public_path__ + "img/instagram_navigation.9a2a9f07.png";